import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b64cc4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "container row" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  class: "card shadow",
  style: {"padding":"1.25rem"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"text-align":"center"} }

import {
  getUserSystem
} from "@/service/apis"
import {
  UserSystemDTO
} from "@/service/interface"
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// 呼叫api, 取得項目清單
const getLang = navigator.language;

const userSystems = ref<UserSystemDTO[]>([]);

(async () => {
  const response = await getUserSystem();
  const resBody: UserSystemDTO[] = response.data.data
  console.log("resBody", resBody);
  userSystems.value = resBody;
  console.log(userSystems.value);
})()

// TODO: 要在改成 db 欄位資料對應圖片位址
const imgPaths = [
  "/main-ui/SKT-icon-值機登入.459c86ea.jpg",
  "/main-ui/SKT-icon-設備管理.149aa78b.jpg",
]

// 測試 env-config
console.log((window as any).VUE_APP_TEST);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userSystems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xxl-2 m-5",
          key: index
        }, [
          _createElementVNode("a", {
            href: item.url,
            style: {"text-decoration":"none"}
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: imgPaths[index],
                alt: "system..."
              }, null, 8, _hoisted_5),
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(getLang) === 'zh-TW' ? item.captionTw : item.cpationTh), 1)
            ])
          ], 8, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}
}

})